import React, { useState, useCallback, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/Home';
import EBrary from './pages/EBrary/EBrary';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ProfilePage from './pages/ProfilePage';
import PasswordPage from './pages/PasswordPage';
import SubjectDetails from './pages/SubjectDetails';
import AppRoutes from "./AppRoutes";
import ReactGA from 'react-ga';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Initialize Google Analytics (Make sure you have your tracking ID set)
ReactGA.initialize("G-VCY1JDQLEP"); // Replace with your GA tracking ID

const AppContent = () => {
  const location = useLocation();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

   // ✅ Handle install prompt
   useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        }
        setDeferredPrompt(null);
        setShowInstallButton(false);
      });
    }
  };


   // Track Page View (this will be tracked on every page visit)
   useEffect(() => {
    const currentPage = location.pathname;
    
    // Send the pageview to Google Analytics
    ReactGA.pageview(currentPage);
    
    // Store the last page visited (optional)
    localStorage.setItem("lastPageVisited", currentPage);
  }, [location]);  // Only re-run when location changes

  const isHomePage = location.pathname === '/';
  const isLoginPage = location.pathname === '/LoginPage';
  const isAfterLogin = [
    '/mycourse',
    '/mylibrary',
    '/course',
    '/book',
    '/elearning',
    '/ebrarycollection',
    '/ejournals',
    '/journal_articles',
    '/usermanagement',
    '/adduser',
    '/edituser',
    '/deleteuser',
    '/librarymanagement',
    '/editbook',
    '/addbook',
    '/deletebook',
    '/usagereports'
  ].some(path => location.pathname.startsWith(path));

  if (isAfterLogin) {
    return <AppRoutes />;
  }




  return (
    
    <>
        <div>
          {showInstallButton && (
            <button onClick={handleInstallClick}>📲 Install eBrary.guru App</button>
          )}
        </div>
       <ToastContainer position="top-center" autoClose={3000} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/EBrary" element={<EBrary />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/LoginPage" element={<LoginPage />} />
        <Route path="/SignupPage" element={<SignupPage />} />
        <Route path="/ForgotPasswordPage" element={<ForgotPasswordPage />} />
        <Route path="/ProfilePage" element={<ProfilePage />} />
        <Route path="/PasswordPage" element={<PasswordPage />} />
        <Route path="/subjects_details/:id" element={<SubjectDetails />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
